import React, { useEffect, useRef, useState } from 'react'
import '../../../scss/pages/Leave/CreateLeave.scss'
import LeftArrow from '../../../asset/svg/leftArrow.svg';
import ApplyLeave from '../../../asset/svg/ApplyLeave.svg';
import { Chip, TextField, Typography } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useLocation, useNavigate, } from 'react-router';
import { LEAVE_PATH } from '../../../utils/Constants';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { APPLY_LEAVE, CANCEL_LEAVE, DELETE_LEAVE_UPLOADEDFILE, GET_UPLOADFILE_OBJECT_ID, SELECTED_CARD_DETAILS } from '../../../sagas/type';
import { getLocalStoreString } from '../../../utils/Helper';
import { useSnackbar } from 'notistack';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { generateRandomId } from '../../../components/common/GenerateRandomId/GenerateRandomId';


var today = new Date();
var dd = today.getDate();
var pd = today.getDate();
var mm = today.getMonth() + 1;
var yyyy = today.getFullYear();
if (dd < 10) { dd = '0' + dd }
if (mm < 10) { mm = '0' + mm }
today = yyyy + '-' + mm + '-' + dd;
const todayDate = yyyy + '-' + mm + '-' + pd;

var lastYear = new Date();
var dd = lastYear.getDate();
var mm = lastYear.getMonth() + 1;
var yyyy = lastYear.getFullYear(today) - 1;
if (dd < 10) { dd = '0' + dd }
if (mm < 10) { mm = '0' + mm }
lastYear = yyyy + '-' + mm + '-' + dd;

var nextYear = new Date();
var dd = nextYear.getDate();
var mm = nextYear.getMonth() + 1;
var yyyy = nextYear.getFullYear(today) + 1;
if (dd < 10) { dd = '0' + dd }
if (mm < 10) { mm = '0' + mm }
nextYear = yyyy + '-' + mm + '-' + dd;


function CreateLeave() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const textareaRef = useRef(null)
    const { enqueueSnackbar } = useSnackbar();
    const EmployeeCode = getLocalStoreString("EmployeeCode");
    const { UploadfileObjectId, SelectedUploadFiles } = useSelector(mapStateToProps);
    const [open, setOpen] = useState(false);
    const [cancelled, setCancelled] = useState(false)
    const [leaveDatas, setLeaveDatas] = useState({
        LeaveType: '',
        LeaveDuration: '',
        FromDate: todayDate,
        ToDate: todayDate,
        Reason: '',
        policyId: 0,
        attachments: []
    });
    const [getlastYear, setGetLastYear] = useState(lastYear);
    const [getnextYear, setGetNextYear] = useState(nextYear);
    const [viewImage, setViewImage] = useState(false);
    const [validDate, setValidDate] = useState(false);
    const [balanceLeave, setBalanceLeave] = useState(0);
    const [validPastDate, setValidPastDate] = useState(true);
    const [appliedCardSelect, setAppliedCardSelect] = useState(false);
    const [validPastThirtyDays, setValidPastThirtyDays] = useState(false);
    const [uploadFieldView, setUploadFieldView] = useState(false)

    const handleChange = (value, name) => {
        setLeaveDatas((leaveDatas) => ({ ...leaveDatas, [name]: value, }));
    };

    const handleFileUpload = (event) => {
        const randomId = generateRandomId(8)
        const file = event.target.files[0];
        const uploadFile = {
            file,
            randomId
        }
        dispatch({
            type: GET_UPLOADFILE_OBJECT_ID,
            payload: { employeeCode: EmployeeCode, uploadFile }
        })
    }

    const isValidForm = () => {
        let flag = true;
        for (const formKey in leaveDatas) {
            const value = leaveDatas[formKey];
            if ((!value && formKey !== "policyId") && !((leaveDatas.LeaveDuration === "FIRST_HALF" || leaveDatas.LeaveDuration === "SECOND_HALF") && formKey === "ToDate")) {
                flag = false
            }
        }
        return flag
    }

    useEffect(() => {
        setLeaveDatas((leaveDatas) => ({ ...leaveDatas, attachments: UploadfileObjectId }));
    }, [UploadfileObjectId])


    useEffect(() => {
        if (location.state?.selectedCardLeaveData) {
            setAppliedCardSelect(true)
            const cardLeaveData = location.state.selectedCardLeaveData
            setLeaveDatas((leaveDatas) => ({ ...leaveDatas, LeaveDuration: cardLeaveData.leaveDuration, LeaveType: cardLeaveData.policyName, FromDate: cardLeaveData.fromDate, ToDate: cardLeaveData.toDate, Reason: cardLeaveData.reason }));
        }
    }, [location.state.selectedCardLeaveData])

    useEffect(() => {
        const applyLeaveType = location.state?.leaveDetailsData?.find((data) => data?.policyName == leaveDatas.LeaveType);
        if (applyLeaveType && Object.keys(applyLeaveType).length > 0) {
            setUploadFieldView(applyLeaveType?.requireProof ? true : false)
        }
    }, [location.state?.leaveDetailsData, leaveDatas])


    useEffect(() => {
        const applyLeave = location.state?.leaveDetailsData?.find((data) => data?.policyName == leaveDatas.LeaveType);
        const today = new Date();
        const leaveFromDate = new Date(leaveDatas?.FromDate)
        const leaveToDate = new Date(leaveDatas?.ToDate)
        const userAppliedDate = Math.floor((Date.UTC(leaveToDate.getFullYear(), leaveToDate.getMonth(), leaveToDate.getDate()) - Date.UTC(leaveFromDate.getFullYear(), leaveFromDate.getMonth(), leaveFromDate.getDate())) / (1000 * 60 * 60 * 24));
        const validThirtyDays = Math.floor((Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) - Date.UTC(leaveFromDate.getFullYear(), leaveFromDate.getMonth(), leaveFromDate.getDate())) / (1000 * 60 * 60 * 24));
        if (leaveDatas.LeaveDuration == 'FULL') {
            if (applyLeave?.balance == 0) {
                setValidDate(true)
                setBalanceLeave(applyLeave?.balance)
            }
            else if (userAppliedDate > applyLeave?.balance) {
                setValidDate(true)
                setBalanceLeave(applyLeave?.balance)
            }
            else {
                setValidDate(false)
            }
            if (validThirtyDays > 30) {
                setValidPastThirtyDays(true)
            } else {
                setValidPastThirtyDays(false)
            }
        }
        else {
            if (applyLeave?.balance == 0) {
                setValidDate(true)
                setBalanceLeave(applyLeave?.balance)
            }
            else if (userAppliedDate > applyLeave?.balance) {
                setValidDate(true)
                setBalanceLeave(applyLeave?.balance)
            }
            else {
                setValidDate(false)
            }
        }
        const currentDate = new Date().setHours(0, 0, 0, 0);
        const appliedToDate = new Date(leaveDatas?.ToDate).setHours(0, 0, 0, 0);
        const appliedFromDate = new Date(leaveDatas?.FromDate).setHours(0, 0, 0, 0);
        if (leaveDatas.LeaveDuration == 'FULL') {
            if (currentDate >= appliedToDate && !(location.state.selectedCardLeaveData?.status == 'PENDING') || !(location.state.selectedCardLeaveData?.status == 'PENDING')) {
                setValidPastDate(false)
            }
        } else {
            if (currentDate >= appliedFromDate && !(location.state.selectedCardLeaveData?.status == 'PENDING') || !(location.state.selectedCardLeaveData?.status == 'PENDING')) {
                setValidPastDate(false)
            }
        }
    }, [leaveDatas])

    const handleMenuClick = (name) => {
        setLeaveDatas((leaveDatas) => ({ ...leaveDatas, policyId: name.policyId, }));
    }

    const handleBack = () => {
        navigate(LEAVE_PATH);
    }

    const handleSubmit = () => {
        const attachments = leaveDatas?.attachments && leaveDatas?.attachments.length > 0 && leaveDatas?.attachments.map(id => {
            const { randomId, ...rest } = id
            return rest
        })
        dispatch({
            type: APPLY_LEAVE,
            payload: {
                employeeCode: EmployeeCode,
                policyId: leaveDatas.policyId,
                fromDate: leaveDatas.FromDate,
                toDate: leaveDatas.LeaveDuration === "FIRST_HALF" || leaveDatas.LeaveDuration === "SECOND_HALF" ? null : leaveDatas.ToDate,
                leaveDuration: leaveDatas.LeaveDuration,
                reason: leaveDatas.Reason,
                attachments: attachments ? attachments : [],
            },
            enqueueSnackbar: enqueueSnackbar,
            setOpen: setOpen
        });
        setOpen(false)
    }

    const handleGoBack = () => {
        setOpen(false);
        handleBack();
    }

    const handleCancelLeave = () => {
        dispatch({
            type: CANCEL_LEAVE,
            payload: {
                employeeCode: EmployeeCode,
                leaveApplicationId: location.state.selectedCardLeaveData.applicationId
            },
            enqueueSnackbar: enqueueSnackbar,
            setOpen: setOpen,
            setViewImage: setViewImage,
            setCancelled: setCancelled,
        });
        setOpen(false)
        setCancelled(false)
    }

    const handleCancelOpen = () => {
        setOpen(true)
        setViewImage(true)
    }
    const disable = isValidForm();

    const handleDelete = (fileData) => {
        const deleteFile = leaveDatas && leaveDatas?.attachments && leaveDatas?.attachments?.length > 0 && leaveDatas?.attachments?.find((data) => data?.randomId == fileData?.randomId);
        dispatch({
            type: DELETE_LEAVE_UPLOADEDFILE,
            payload: {
                deleteFile: deleteFile,
                employeeCode: EmployeeCode,
                enqueueSnackbar: enqueueSnackbar,
            },
        })
    }

    const handleTextAreaFocus = () => {
        if (textareaRef.current) {
            textareaRef.current.scrollIntoView({ behaviour: 'smooth', block: 'center' })
        }
    }
    console.log('SelectedUploadFiles', SelectedUploadFiles);
    return (
        <div className='createLeave-Container'>
            <div className='createLeave-Container_header'>
                <div>
                    <img className='createLeave-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='createLeave-Container_header_content'>Leave</span>
                </div>
                {location.state?.cardViewed && <Chip label={location.state.selectedCardLeaveData?.status} color={location.state.selectedCardLeaveData?.status == 'APPROVED' ? 'success' : location.state.selectedCardLeaveData?.status == 'PENDING' ? 'warning' : 'error'} variant="outlined" />}
            </div>
            <div>
                <Typography className='createLeave-Container_leavetype'>Leave Type</Typography>
            </div>
            <div>
                <FormControl disabled={appliedCardSelect} sx={{ "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#FFFFFF", }, width: 316, m: 1, background: `${leaveDatas?.LeaveType?.length > 0 ? 'radial-gradient(84.52% 84.52% at 50% 15.48%, rgba(128, 116, 255, 0.3) 0%, rgba(128, 116, 255, 0.3) 100%), rgba(255, 255, 255, 0.06);' : 'rgba(255,255,255,0.18)'}`, color: `${leaveDatas?.LeaveType?.length > 0 && appliedCardSelect ? 'white' : 'gray'}`, borderRadius: '12px', }} >
                    {!leaveDatas?.LeaveType?.length > 0 && <InputLabel id="demo-multiple-name-label" sx={{ color: 'gray', '&:focus': { display: 'none' } }}>Select Leave</InputLabel>}
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        value={leaveDatas?.LeaveType}
                        name='LeaveType'
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        input={<OutlinedInput label="Leave Type" />}
                        sx={{ color: `${leaveDatas?.LeaveType?.length > 0 || appliedCardSelect ? 'white' : 'gray'}`, fontSize: '11px', }}
                    >
                        {location?.state && location?.state.leaveDetailsData.length > 0 && location?.state.leaveDetailsData.map((name) => (
                            <MenuItem onClick={() => handleMenuClick(name)}
                                key={name.policyName}
                                value={name.policyName}
                                sx={{ color: 'gray', backgroundColor: 'white', '& .Mui-selected': { backgroundColor: 'white' }, }}
                            >
                                {name.policyName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div>
                <Typography className='createLeave-Container_leaveduration'>Leave Duration</Typography>
            </div>
            <div>
                <FormControl >
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue=""
                        name="LeaveDuration"
                    >
                        <FormControlLabel disabled={appliedCardSelect} onChange={(event) => handleChange(event.target.value, event.target.name)} sx={{ "& .MuiFormControlLabel-label.Mui-disabled": { WebkitTextFillColor: `${leaveDatas?.LeaveDuration == 'FULL' ? 'white' : 'gray'}` }, '& .MuiRadio-root': { color: `${leaveDatas?.LeaveDuration == 'FULL' ? 'white' : 'gray'}` }, '& .MuiFormControlLabel-label': { fontSize: '12px' }, m: 1, fontSize: '12px', color: `${leaveDatas?.LeaveDuration == 'FULL' ? 'white' : 'gray'}`, background: `${leaveDatas?.LeaveDuration == 'FULL' ? 'radial-gradient(84.52% 84.52% at 50% 15.48%, rgba(128, 116, 255, 0.3) 0%, rgba(128, 116, 255, 0.3) 100%), rgba(255, 255, 255, 0.06);' : 'rgba(255,255,255,0.18)'}`, borderRadius: '12px', padding: '6px', }} value="FULL" control={<Radio />} label="Full Day" />
                        <div style={{ display: 'flex' }}>
                            <FormControlLabel disabled={appliedCardSelect} onChange={(event) => handleChange(event.target.value, event.target.name)} sx={{ "& .MuiFormControlLabel-label.Mui-disabled": { WebkitTextFillColor: `${leaveDatas?.LeaveDuration == 'FIRST_HALF' ? 'white' : 'gray'}`, }, '& .MuiRadio-root': { color: `${leaveDatas?.LeaveDuration == 'FIRST_HALF' ? 'white' : 'gray'}` }, '& .MuiFormControlLabel-label': { fontSize: '12px' }, width: 140, m: 1, color: `${leaveDatas?.LeaveDuration == 'FIRST_HALF' ? 'white' : 'gray'}`, background: `${leaveDatas?.LeaveDuration == 'FIRST_HALF' ? 'radial-gradient(84.52% 84.52% at 50% 15.48%, rgba(128, 116, 255, 0.3) 0%, rgba(128, 116, 255, 0.3) 100%), rgba(255, 255, 255, 0.06);' : 'rgba(255,255,255,0.18)'}`, borderRadius: '12px', padding: '6px' }} value="FIRST_HALF" control={<Radio />} label="First Half" />
                            <FormControlLabel disabled={appliedCardSelect} onChange={(event) => handleChange(event.target.value, event.target.name)} sx={{ "& .MuiFormControlLabel-label.Mui-disabled": { WebkitTextFillColor: `${leaveDatas?.LeaveDuration == 'SECOND_HALF' ? 'white' : 'gray'}`, }, '& .MuiRadio-root': { color: `${leaveDatas?.LeaveDuration == 'SECOND_HALF' ? 'white' : 'gray'}` }, '& .MuiFormControlLabel-label': { fontSize: '12px' }, width: 140, m: 1, color: `${leaveDatas?.LeaveDuration == 'SECOND_HALF' ? 'white' : 'gray'}`, background: `${leaveDatas?.LeaveDuration == 'SECOND_HALF' ? 'radial-gradient(84.52% 84.52% at 50% 15.48%, rgba(128, 116, 255, 0.3) 0%, rgba(128, 116, 255, 0.3) 100%), rgba(255, 255, 255, 0.06);' : 'rgba(255,255,255,0.18)'}`, borderRadius: '12px', padding: '6px' }} value='SECOND_HALF' control={<Radio />} label="Second Half" />
                        </div>
                    </RadioGroup>
                </FormControl>
            </div>
            <div>
                <Typography className='createLeave-Container_dateduration'>Date Duration</Typography>
            </div>
            <div className='createLeave-Container_datecontainer'>
                <input className={`${leaveDatas?.FromDate?.length > 0 ? 'createLeave-Container_datecontainer_selected-fromDate' : 'createLeave-Container_datecontainer_fromDate'}`} placeholder='Start Date' type="date" id="start"
                    value={leaveDatas?.FromDate}
                    disabled={appliedCardSelect}
                    name='FromDate' min={getlastYear} max={getnextYear}
                    onChange={(event) => handleChange(event.target.value, event.target.name)} />
                {leaveDatas.LeaveDuration == ('FULL' || '') && <input className={`${leaveDatas?.ToDate?.length > 0 ? 'createLeave-Container_datecontainer_selected-toDate' : 'createLeave-Container_datecontainer_toDate'}`} placeholder='End Date' type="date" id="end"
                    value={leaveDatas?.ToDate} name='ToDate' disabled={appliedCardSelect} min={leaveDatas?.FromDate} max={getnextYear}
                    onChange={(event) => handleChange(event.target.value, event.target.name)} />}
            </div>
            {(validDate && !appliedCardSelect) && <div className='createLeave-Container_errorContent-container'>
                <Typography fontStyle='normal' fontWeight='600' fontSize='11px' lineHeight='10px' alignItems='center' color='#F95F5F;' textAlign='center'>{balanceLeave} days leave balance left</Typography>
            </div>}
            {validPastThirtyDays && <div className='createLeave-Container_errorContent-container'>
                <Typography fontStyle='normal' fontWeight='600' fontSize='11px' lineHeight='10px' alignItems='center' color='#F95F5F;' textAlign='center'>Cannot apply leave more than 30 days in the past</Typography>
            </div>}
            {uploadFieldView && <div>
                <div>
                    <Typography className='createLeave-Container_fileUpload'>Upload Document</Typography>
                </div>
                <div className='createLeave-Container_fileUpload-container'>
                    {!SelectedUploadFiles?.length > 0 && <div className={`${!SelectedUploadFiles?.length > 0 ? 'createLeave-Container_fileUpload-container_choosed-field' : 'createLeave-Container_fileUpload-container_choose-field'}`}  >
                        <label htmlFor="upload-file" style={{ cursor: 'pointer', backgroundColor: 'rgba(255,255,255,0.03)', color: 'rgba(255,255,255,0.3)', border: ' 1px dashed rgba(255, 255, 255, 0.12)', boxShadow: '0px 4px 4px 1px rgba(0, 0, 0, 0.08)', borderRadius: '8px', padding: '10px' }}>Upload a File</label>
                        <input style={{ opacity: 0, zIndex: -1 }}
                            type='file' id='upload-file' multiple
                            onChange={handleFileUpload} name='File' placeholder='Upload a File' />
                    </div>}
                    {SelectedUploadFiles && SelectedUploadFiles.length > 0 && <div className='createLeave-Container_fileUpload-container_choose-field'>
                        {SelectedUploadFiles && SelectedUploadFiles.length > 0 && SelectedUploadFiles.map((doc) => {
                            return (
                                <div onClick={() => handleDelete(doc)} style={{ fontWeight: 500, fontSize: '12px', lineHeight: '12px', cursor: 'pointer', backgroundColor: 'rgba(255,255,255,0.03)', color: 'rgba(255,255,255,0.8)', border: ' 1px dashed rgba(255, 255, 255, 0.12)', boxShadow: '0px 4px 4px 1px rgba(0, 0, 0, 0.08)', borderRadius: '8px', padding: '5px', width: '231px' }}>{doc?.name} <span><IconButton aria-label="close" sx={{ color: '#FFFFFF', position: 'relative', left: '60px', bottom: '10px' }} >
                                    <CloseIcon sx={{ color: 'gray', width: '1rem' }} />
                                </IconButton></span></div>
                            )
                        })
                        }
                    </div>}
                    {SelectedUploadFiles && SelectedUploadFiles.length > 0 && <div className='createLeave-Container_fileUpload-container_AddMore-container' >
                        <label htmlFor="upload-file" className='createLeave-Container_fileUpload-container_AddMore-container_AddMore-button' >+ Add More</label>
                        <input style={{ opacity: 0, zIndex: -1 }}
                            type='file' id='upload-file' multiple
                            onChange={handleFileUpload} name='File' placeholder='Upload a File' />
                    </div>}
                </div>
            </div>}
            <div>
                <Typography className='createLeave-Container_reasonForLeave'>Reason For Leave</Typography>
            </div>
            <div>
                <FormControl sx={{ "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#FFFFFF", }, m: 1, width: 300, backgroundColor: 'rgba(255,255,255,0.18)', color: 'red', borderRadius: '12px' }}>
                    <TextField
                        fullWidth
                        multiline
                        InputProps={{ rows: 3, }}
                        InputLabelProps={{ style: { color: 'gray' }, }}
                        value={leaveDatas?.Reason}
                        name='Reason'
                        placeholder='Type Here'
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        disabled={appliedCardSelect}
                        inputRef={textareaRef}
                        onFocus={handleTextAreaFocus}
                    />
                </FormControl>
            </div>
            <div className='createLeave-Container_applybutton-container'>
                {location.state?.cardViewed ? validPastDate && <button onClick={handleCancelOpen} className='createLeave-Container_applybutton-container_cancelButton'>Cancel Leave</button> :
                    <button disabled={!disable || validDate || (validPastThirtyDays)} onClick={handleSubmit} className={`${!disable || validDate || (validPastThirtyDays) ? 'createLeave-Container_applybutton-container_disableButton' : 'createLeave-Container_applybutton-container_applyButton'}`}  >Apply Leave</button>
                }
            </div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <div className='createLeave-Container_boxContainer'>
                    <Box sx={{ backgroundColor: (cancelled || !location.state?.cardViewed) ? 'white' : '#0B245F;', borderRadius: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', }}>
                        {!viewImage && <img className='createLeave-Container_applyleavelogo' src={ApplyLeave} alt="" />}&nbsp;&nbsp;
                        {location.state?.cardViewed ?
                            <div>
                                <Typography className={cancelled ? 'createLeave-Container_applyleavecontent' : 'createLeave-Container_cancelleavecontent'} > {cancelled ? 'Leave cancelled' : 'Are you sure you want to cancel leave ?'}  </Typography>
                                {cancelled && <Typography className='createLeave-Container_applyleavecontent_subContent'>Enjoy your day</Typography>}
                                {cancelled ? <div className='createLeave-Container_okbutton-container'>
                                    <button className='createLeave-Container_okbutton-container_button' onClick={handleGoBack}>Okay</button>
                                </div> :
                                    <div className='createLeave-Container_okbutton-container'>
                                        <button onClick={handleCancelLeave} className='createLeave-Container_okbutton-container_button' >Yes</button>
                                        <button onClick={() => setOpen(false)} className='createLeave-Container_okbutton-container_nobutton' >No</button>
                                    </div>}
                            </div>
                            :
                            <div>
                                <Typography className='createLeave-Container_applyleavecontent'>Leave Applied</Typography>
                                <Typography fontSize='12px' padding='10px' textAlign='center'>Sent for approval</Typography>
                                <div className='createLeave-Container_okbutton-container'>
                                    <button className='createLeave-Container_okbutton-container_button' onClick={handleGoBack}>Okay</button>
                                </div>
                            </div>
                        }
                    </Box>
                </div>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        UploadfileObjectId: state.leaveConfig.UploadfileObjectId,
        SelectedUploadFiles: state.leaveConfig.SelectedUploadFiles,
    }
}

export default CreateLeave;